// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__cDKZL","search":"Settings_search__1oxfn","filter":"Settings_filter__1skMu"};